import React, {Component} from "react" 
import logoutIcon from "../images/logout.svg";

 class ButtonLogout extends Component {
  
    onClickLogout = ()=>{
      localStorage.setItem("token", null);
      window.location="/";
    }

    render() {
     return(
        <img src={logoutIcon} style={{cursor: 'pointer'}} onClick={this.onClickLogout} width={30}/>
     );
    }
 }
 export default ButtonLogout;